import React from 'react';

export const LoadingComponent = () => {
    return <div className='loading-container-div'>
        <lottie-player key='loading-data' src="https://lottie.host/82f0f876-48b6-41ae-a157-0789ee1b7981/yc1xEHYKrX.json" background="transparent" speed="1" style={{ width: 400, height: 400 }} loop autoplay></lottie-player>
    </div>
}